import { translate } from '@portal/services/i18n';
import React from 'react';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import AdvancedCard from '@portal/components/AdvancedCard/AdvancedCard';
import './AdvancedPanelContentHeader.less';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface AdvancedPanelContentHeaderProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  goBackAction?: () => void;
  icon?: React.ReactNode;
  testId: string;
  buttonTitle?: string;
}

const AdvancedPanelContentHeader = ({
  title,
  description,
  goBackAction,
  icon,
  testId,
  buttonTitle,
}: AdvancedPanelContentHeaderProps) => {
  return (
    <AdvancedCard testId="card-panel-header">
      <div className="advanced-panel-content-header" data-testid={testId}>
        {goBackAction ? (
          <AdvancedButton
            text={
              buttonTitle || translate('PAGES.CARDS.MY_CARDS.BUTTONS.GO_BACK')
            }
            variant="outlined"
            onClick={() => goBackAction()}
            testId="go-back-button"
          />
        ) : null}
        <div>
          {icon ? <div>{icon}</div> : null}
          <ThemedText
            variant="h4"
            className="advanced-panel-content-header__title"
          >
            {title}
          </ThemedText>
          <ThemedText
            variant="body"
            className="advanced-panel-content-header__description"
          >
            {description}
          </ThemedText>
        </div>
      </div>
    </AdvancedCard>
  );
};

export default AdvancedPanelContentHeader;
